import{makeAccessor}from"../core/index.js";export const bannerAppearance=makeAccessor(["neutral","success","attention","warning"]);
//# sourceMappingURL=banner.props.js.map